import { dateFormat } from "core/datetime";
import { FC } from "react";

interface Props {
  date: string;
  showTime?: boolean;
}

interface FormatOptions {
  format: string;
  timeZone?: string;
}

export const DateFormatter: FC<Props> = ({ date, showTime = false }) => {
  const newDate = new Date(date);

  let dateFormatOptions: FormatOptions = {
    format: showTime ? "Do MMM YYYY h:mma" : "Do MMM YYYY"
  };

  // Check if date passed in has time (is datetime)
  if (showTime && !newDate.getUTCMinutes()) {
    dateFormatOptions.timeZone = "utc";
  }

  return (
    <time dateTime={date}>
      {/* @ts-ignore (dateFormat is not typed) */}
      {date ? dateFormat(date, dateFormatOptions) : "-"}
    </time>
  );
};
DateFormatter.displayName = "DateFormatter";
